import { render, staticRenderFns } from "./tag-item.vue?vue&type=template&id=8aff9e62&scoped=true&"
import script from "./tag-item.vue?vue&type=script&lang=js&"
export * from "./tag-item.vue?vue&type=script&lang=js&"
import style0 from "./tag-item.vue?vue&type=style&index=0&id=8aff9e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aff9e62",
  null
  
)

export default component.exports